// src/components/CustomFields/fields/InputMultiTextField.tsx
// InputMultiTextField component migrated from legacy

import React from 'react';
import CustomFieldsService from '../../../api/CustomFieldsService';
import $ from 'jquery';
import RichTextEditor from './RichTextEditor';
import { Popover } from 'react-bootstrap';
import '../../Globals/ComponentHelpers.css';
import './InputMultiTextField.css';
import ClickOutSide from '../../Globals/ClickOutSide';
import { RenderInBody } from '../../Globals';
import shortid from 'shortid';
import { isSafari } from './DOMHelper';
import type { BaseFieldProps, CustomFieldItem } from './types';
import { addTargetBlankToLinks } from '@/lib/linkUtils';

interface InputMultiTextFieldState {
  value: string;
  body: string;
  EditorEnabled: boolean;
  editableValue: string;
  disableAutoSave: boolean;
  customField: CustomFieldItem;
  canEdit: boolean;
  apiConfig: { url: string; token: string };
  showPopup: boolean;
  popUpOpen: boolean;
  popUpPosition: 'left' | 'right';
  isItemDetails: boolean;
  isFromInfoWindow: boolean;
  elementId: string;
  modalWidth: number;
  modalheight: number;
  modalPosition: { left: number; top: number };
}

class InputMultiTextField extends React.Component<BaseFieldProps, InputMultiTextFieldState>
{
  private popoverRef = React.createRef<HTMLDivElement>();

  constructor(props: BaseFieldProps)
  {
    super(props);
    const cf = props.customField;

    this.state = {
      value: cf.Value === null ? '' : String(cf.Value),
      body: cf.Value === null ? '' : String(cf.Value),
      EditorEnabled: props.EditorEnabled || false,
      editableValue: '',
      disableAutoSave: props.disableAutoSave || false,
      customField: cf,
      canEdit: props.canEdit && cf.ConversationIsEnable !== false,
      apiConfig: props.apiConfig,
      showPopup: false,
      popUpOpen: false,
      popUpPosition: 'left',
      isItemDetails: window.location.href.indexOf('ConversationDetails') > -1,
      isFromInfoWindow: false,
      elementId: shortid.generate(),
      modalWidth: 300,
      modalheight: 302,
      modalPosition: {
        left: 0,
        top: 0,
      },
    };

    this.handleClose = this.handleClose.bind(this);
    this.save = this.save.bind(this);
    this.enableEditor = this.enableEditor.bind(this);
    this.disableEditor = this.disableEditor.bind(this);
    this.onChangeSummernote = this.onChangeSummernote.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onUpdateCustomField = this.onUpdateCustomField.bind(this);
    this.validatePosition = this.validatePosition.bind(this);
  }

  componentDidMount()
  {
    if (this.popoverRef.current)
    {
      const containerElement = $(this.popoverRef.current);
      if (containerElement.closest('.details-tab-directive').length > 0)
      {
        this.setState({ isFromInfoWindow: true });
      }
    }
  }

  componentWillReceiveProps(nextProps: BaseFieldProps)
  {
    // Only update if the value actually changed to prevent infinite loops
    const currentValue = String(this.state.customField.Value || '');
    const nextValue = String(nextProps.customField.Value || '');

    if (
      currentValue !== nextValue ||
      this.state.customField.CustomFieldId !== nextProps.customField.CustomFieldId
    )
    {
      this.setState({
        customField: nextProps.customField,
        body: nextProps.customField.Value === null ? '' : String(nextProps.customField.Value),
      });
    }
  }

  handleClose()
  {
    this.setState({ popUpOpen: false });
  }

  onChangeSummernote(content: string)
  {
    this.setState({ value: content });
  }

  handleClick()
  {
    this.setState({ showPopup: false });
    this.disableEditor();
  }

  save()
  {
    const { value, editableValue, disableAutoSave, body } = this.state;

    const copyCustomField = { ...this.state.customField };

    // We make sure that the new value is different to the previous one
    if (value !== editableValue && value != null)
    {
      // Assign the new values
      copyCustomField.Value = value;
      copyCustomField.PreviousValue = body;
      this.setState({ editableValue: value, body: value });

      this.disableEditor();

      // Do not save if autoSaved is disabled
      if (!disableAutoSave)
      {
        const requestSave = {
          api: this.props.apiConfig,
          request: copyCustomField,
        };

        if (
          copyCustomField.CustomFieldValueId === undefined ||
          copyCustomField.CustomFieldValueId === null ||
          copyCustomField.CustomFieldValueId === 0
        )
        {
          CustomFieldsService.savePost(requestSave).then((data: any) =>
          {
            copyCustomField.CustomFieldValueId = data.CustomFieldValueId;

            try
            {
              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
        else
        {
          CustomFieldsService.save(requestSave).then(() =>
          {
            try
            {
              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
      }
      else
      {
        this.setState({ customField: copyCustomField }, () =>
        {
          this.onUpdateCustomField();
        });
      }
    }
    else
    {
      // Disable the control
      this.disableEditor();
    }
  }

  enableEditor()
  {
    const { canEdit, value } = this.state;
    if (canEdit)
    {
      this.validatePosition();

      $('.corgee_com_text-editor-container').remove();
      $('body').find('.note-popover').attr('style', 'display:none');

      const element = $(this.popoverRef.current!);
      element.closest('.layer-details-container').css('overflow', 'hidden');

      const scrollPositionY = $('.core2').scrollTop();

      this.setState(
        {
          EditorEnabled: true,
          editableValue: value,
          showPopup: true,
          popUpOpen: !this.state.popUpOpen,
        },
        () =>
        {
          const windowModal = $('.conversation-editor');
          const element$ = $(this.popoverRef.current!);
          const control = element$.find('#select-popover-' + this.state.elementId);
          let top = 0;
          let left = 0;

          if (scrollPositionY !== $('.core2').scrollTop())
          {
            $('.core2').scrollTop(scrollPositionY || 0);
          }

          if (
            windowModal.offset() &&
            windowModal.length > 0 &&
            windowModal.find('[id*="select-render"]').length > 0
          )
          {
            left = control.offset()!.left - windowModal.offset()!.left;
            top = control.offset()!.top + 35 - windowModal.offset()!.top;
          }
          else
          {
            if (control.length > 0)
            {
              if (this.state.popUpPosition === 'right')
              {
                left = control.offset()!.left + element$.width()! + 3;
              }
              else
              {
                left = control.offset()!.left - this.state.modalWidth - 3;
              }
              top =
                element$.offset()!.top +
                35 -
                this.state.modalheight / 2 -
                ($('html').scrollTop() || 0);
              top = top + ($('.core2').scrollTop() || 0) - 10;
              if (isSafari())
              {
                top = top - ($('body').scrollTop() || 0);
              }
            }
          }

          this.setState({
            modalPosition: {
              left: left,
              top: top,
            },
          });

          setTimeout(() =>
          {
            element$.closest('.layer-custom-fields-container').on('scroll', () =>
            {
              this.disableEditor();
            });

            element$.closest('.corgee_com_card-body-info').on('scroll', () =>
            {
              this.disableEditor();
            });
          }, 100);
        },
      );
    }
  }

  disableEditor()
  {
    this.setState({ EditorEnabled: false, showPopup: false });
    const element = $(this.popoverRef.current!);
    element.closest('.layer-details-container').css('overflow', '');
    element.closest('.layer-details-container').off('scroll');
    element.closest('.card-body-area').off('scroll');
    element.closest('md-dialog-content').off('scroll');
    element.closest('.add-inline-task').off('scroll');
    element.closest('.corgee_com_card-body-info').off('scroll');
  }

  onUpdateCustomField()
  {
    if (this.props.UpdateCustomFields)
    {
      this.props.UpdateCustomFields(this.state.customField);
    }
  }

  validatePosition()
  {
    if (this.state.isFromInfoWindow)
    {
      let containerDetails = $('.LayersDetailInforWindow');
      const control = $(this.popoverRef.current!);

      if (containerDetails.length === 0)
      {
        containerDetails = $(
          '.corgee_com_custom-fields-container.details-tab-animation-content.layer-details-container',
        );
      }

      if (window.innerWidth - ((control.offset() as any)?.right || 0) + 5 < 300)
      {
        this.setState({ popUpPosition: 'right' });
      }
    }
    else
    {
      const control = $(this.popoverRef.current!);

      if ((control.offset()?.left || 0) < 300)
      {
        this.setState({ popUpPosition: 'right' });
      }
    }
  }

  render()
  {
    const { canEdit, body, customField, showPopup, popUpPosition, modalPosition, modalWidth, value } =
      this.state;
    const containerSelectorId = 'select-popover-' + this.state.elementId;

    const clickOutSideWhiteList = [
      { type: 'class', value: 'modal' },
      { type: 'class', value: 'modal-dialog' },
      { type: 'class', value: 'modal-title' },
      { type: 'class', value: 'modal-body' },
      { type: 'class', value: 'modal-header' },
      { type: 'class', value: 'modal-content' },
      { type: 'class', value: 'modal-footer' },
      { type: 'class', value: 'form-group' },
      { type: 'class', value: 'form-control' },
      { type: 'class', value: 'note-link-btn' },
      { type: 'class', value: 'note-image-btn' },
      { type: 'class', value: 'popover-content' },
      { type: 'class', value: 'link-popover-custom-container' },
      { type: 'class', value: 'icon-editor-link' },
      { type: 'class', value: 'note-icon-chain-broken' },
      { type: 'element', value: 'label' },
      { type: 'element', value: 'span', elementValue: '×' },
      { type: 'element', value: 'a', attr: 'target', attrValue: '_blank' },
    ];

    const showFullText = () =>
    {
      const tmp = document.implementation.createHTMLDocument('New').body;
      tmp.innerHTML = body;
      const strBody = tmp.textContent || tmp.innerText || '';
      let text = 'Not Set';

      if (strBody !== 'undefined' && strBody !== null)
      {
        if (strBody.trim() !== '' || body.includes('src'))
        {
          text = body;
        }
      }
      return { __html: addTargetBlankToLinks(text) };
    };

    return (
      <div
        key={'cf-' + customField.CustomFieldId}
        ref={this.popoverRef}
        id={'cf-' + customField.CustomFieldId}
        className="corgee_com_custom-fields-field-B _DEL_field-B custom-field-id corgee_com_text-editor-remove-overflow"
      >
        {customField.GroupMultiEditionType === 1 && (
          <i
            className="material-icons several-values enable-help-tooltip"
            title="Not all cards selected have this detail. The detail value will change only on applicable cards."
            data-title="Not all cards selected have this detail. The detail value will change only on applicable cards."
          >
            do_not_disturb_on
          </i>
        )}
        <span className="corgee_com_custom-fields-title _DEL_title">{customField.Name}</span>
        {!customField.GroupMultiEditionType && (
          <i
            className="material-icons not-filterable enable-help-tooltip"
            data-title="This detail type is not filterable"
          >
            do_not_disturb_on
          </i>
        )}

        <div id="editable-text-label" className="click-to-edit">
          <div className="custom-text-directive-content-listener">
            <div className="custom-text-directive-body-content">
              <div
                dangerouslySetInnerHTML={showFullText()}
                onClick={this.enableEditor}
                className={canEdit ? 'lbl-editable-input' : 'lbl-non-editable-input'}
              ></div>
            </div>
          </div>
          <div className="custom-field-action tdc-see-more-trigger"></div>
        </div>

        {showPopup && (
          <div id={containerSelectorId}>
            <RenderInBody
              containerClassName="summerNote"
              containerStyles={
                'top:' +
                modalPosition.top +
                'px; left:' +
                modalPosition.left +
                'px; zIndex:100; position: absolute; z-index: 1000;'
              }
            >
              <Popover
                placement={popUpPosition}
                id="popover-basic"
                style={{ width: modalWidth + 'px', zIndex: '100' }}
                className="corgee_com_text-editor-container _DEL_text-editor-container"
              >
                <ClickOutSide onClickOutSide={this.disableEditor} whiteList={clickOutSideWhiteList}>
                  <div className="corgee_com_text-editor-header _DEL_text-editor-header">
                    <div
                      className="corgee_com_text-editor-close-control _DEL_text-editor-close-control"
                      onClick={this.handleClick}
                    >
                      <i className="icon-incorrect-icon"></i>
                    </div>
                  </div>
                  <div className="corgee_com_text-editor-control _DEL_text-editor-control">
                    <RichTextEditor onChangeBody={this.onChangeSummernote} body={value} />
                  </div>
                  <div className="corgee_com_text-editor-footer _DEL_text-editor-footer">
                    <button
                      onClick={this.save}
                      className="corgee_com_button corgee_com_button-primary _DEL_corgee-button"
                    >
                      Save
                    </button>
                  </div>
                </ClickOutSide>
              </Popover>
            </RenderInBody>
          </div>
        )}
      </div>
    );
  }
}

export default InputMultiTextField;
